import { registerRouteForModule } from '@/common/route/registerModules';
import router from './router';

export default registerRouteForModule(router);
